import React from 'react';
import {Link} from 'react-router';
import {List} from 'immutable';
import moment from 'moment';

import CoachingAgendaContainer from 'components/dashboard/CoachingAgendaContainer';
import ManagerCTA from 'components/dashboard/ManagerCTA';
import ManagerTeamRankings from 'components/dashboard/ManagerTeamRankings';
import UserAvatar from 'components/pure/utils/UserAvatar';
import AuthStore from 'stores/AuthStore';
import './ManagerSummaryDashboard.styl';
import ManagerCoachingEffectiveness from 'components/dashboard/manager/ManagerCoachingEffectiveness';
import WideSuggestedAction from 'components/dashboard/admin/WideSuggestedAction';
import DashboardV2LoadingOverlay from 'components/manager-dashboard/DashboardV2LoadingOverlay';
import connectToStores from 'alt-utils/lib/connectToStores';
import UpcomingReviewsStore from 'stores/coaching/UpcomingReviewsStore';
import AccountStore from 'stores/AccountStore';
import ManagerNewAccount from 'components/dashboard/manager/ManagerNewAccount';
import AccountActions from 'actions/AccountActions';
import Loading from 'components/pure/utils/Loading';
import CoachingQuickReminders from 'components/dashboard/CoachingQuickReminders';

import withCoachingPlanWizard from 'components/coaching/wizard/withCoachingPlanWizard';
import hasFlag from 'utils/hasFlag';
import {featureFlags} from 'utils/const';
import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';
import NineBoxContainer from 'components/dashboard/manager/nine-box/NineBoxContainer';
import {CTARole} from 'components/dashboard/ManagerCTA.utils';

@connectToStores
class ManagerSummaryDashboard extends React.Component {
  static getStores() {
    return [UpcomingReviewsStore, AccountStore, AuthStore];
  }

  static getPropsFromStores({managerId}) {
    const accountStore = AccountStore.getState();
    const twoWeeksAgo = moment().subtract(2, 'weeks');
    const recentlyMade = twoWeeksAgo.isBefore(accountStore.createdDate);
    const reviews = UpcomingReviewsStore.getState().upcomingReviewsMap.get(managerId, List());
    return {
      authUser: AuthStore.getState().user,
      managerId,
      isNewAccount: recentlyMade && reviews.isEmpty(),
      createdDateLoading: accountStore.createdDateLoading,
      createdDateFetched: accountStore.createdDateFetched,
    };
  }

  componentDidMount() {
    !this.props.createdDateFetched && AccountActions.fetchCreatedDate.defer();

    const {managerId} = this.props;
    // driven by the reviews, but we need plan info too
    CoachingPlanActions.fetchForCoaches.defer([managerId], {
      includeReviews: true,
      includeCompleted: true,
    });
  }

  handleCreatePlan = rep => {
    const {manager} = this.props;

    this.props.onCreatePlan({rep, coach: manager});
  };

  render() {
    const {
      authUser,
      location,
      managerId,
      manager: managerToDisplay,
      admin,
      isNewAccount,
      createdDateLoading,
      hasRenderedDashv2Gif,
      startDate,
      endDate,
      selectedTeam,
    } = this.props;
    const ownSummary = authUser.id === (managerToDisplay && managerToDisplay.id);

    const isLoading = !hasRenderedDashv2Gif;
    return (
      <div className="manager-summary-dashboard">
        <DashboardV2LoadingOverlay />

        <div style={isLoading ? {maxHeight: 'calc(100vh - 56px)'} : undefined}>
          <div className="top-row">
            {managerToDisplay && (
              <div className="manager-profile">
                <UserAvatar user={managerToDisplay} />
                <div className="manager-details">
                  <div className="manager-name">{managerToDisplay.getFullName()}</div>
                  {ownSummary && (
                    <Link className="generic-link manager-profile-link" to={'/admin/profile'}>
                      Edit Profile
                    </Link>
                  )}
                </div>
              </div>
            )}
            {ownSummary ? (
              <div className="ctas-container">
                <ManagerCTA {...this.props} role={CTARole.MANAGER} />
              </div>
            ) : (
              // protect this and managercoachingeffectiveness w/ admin user being loaded -
              // ownSummary may not be loaded yet, use admin as our safety net
              // managers should never see these
              admin && <WideSuggestedAction {...this.props} manager={managerToDisplay} />
            )}
          </div>
          <CoachingQuickReminders location={location} />

          {hasFlag(featureFlags.enhancedManagerDash) && (
            <NineBoxContainer
              location={location}
              startDate={startDate}
              endDate={endDate}
              managerId={managerId}
              adminId={admin?.id}
              selectedTeamId={selectedTeam?.id}
              onCreatePlan={this.handleCreatePlan}
              managerToDisplay={managerToDisplay}
              ownSummary={ownSummary}
            />
          )}

          {createdDateLoading ? (
            <Loading />
          ) : (
            <div>
              {ownSummary && isNewAccount && <ManagerNewAccount />}
              {ownSummary ? (
                <CoachingAgendaContainer {...this.props} isNewAccount={isNewAccount} />
              ) : (
                admin && (
                  <ManagerCoachingEffectiveness
                    {...this.props}
                    managerId={managerToDisplay && managerToDisplay.id}
                    rows={4}
                    showMoreLink={location.pathname.replace('summary', 'coaching-effectiveness')}
                  />
                )
              )}
              {!isNewAccount && (
                <div className="standalone-widget-wrapper team-rankings-container">
                  <ManagerTeamRankings hideRecentlyRequested={!ownSummary} {...this.props} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withCoachingPlanWizard(ManagerSummaryDashboard);
